import config from 'constants/config'
import React from 'react'
import ExpiredLereRenderGuard from '../RenderGuard/ExpiredLereRenderGuard'
import UnavailableYouMayAlsoLike from 'components/Recommendations/YouMayAlsoLike/Expired/UnavailableYouMayAlsoLike'

import ExpiredDealsHero from './ExpiredDealsHero'

interface Props {
  hideOffers: boolean
}

function ExpiredDealsLereRecommendations({
  hideOffers,
}: Props) {
  return (
    <ExpiredLereRenderGuard>
      {!config.LERE_EXPIRED_DEALS_V2_ENABLED && <UnavailableYouMayAlsoLike hideOffers={hideOffers} />}
      {config.LERE_EXPIRED_DEALS_V2_ENABLED && <ExpiredDealsHero />}
    </ExpiredLereRenderGuard>
  )
}

export default ExpiredDealsLereRecommendations
